document.addEventListener('DOMContentLoaded', function () {

  var PRECIOS_EXTRA = {
    '55804672606556': 100, '55804686696796': 50, '55804682731868': 25,
    '55804677620060': 120, '55983149613404': 150, '55983173173596': 30,
    '55957898985820': 15,  '55861422883164': 20,  '55804909683036': 45,
    '55958042706268': 65,  '55804930851164': 35
  };

  function recogerExtras() {
    var agrupados = {};
    document.querySelectorAll('div[class*="formular"] select').forEach(function(s) {
      var o = s.options[s.selectedIndex];
      if (o && o.getAttribute('data-extra-id')) {
        var id = o.getAttribute('data-extra-id');
        agrupados[id] = (agrupados[id] || 0) + 1;
      }
    });
    return agrupados;
  }

  function actualizarPrecio() {
    var extras = recogerExtras();
    var totalExtras = 0;
    Object.keys(extras).forEach(function(id) {
      totalExtras += (PRECIOS_EXTRA[id] || 0) * extras[id];
    });
    var indicador = document.getElementById('smprw-precio-extras');
    if (!indicador) return;
    var precioBaseEl = document.querySelector('.price-item--regular');
    if (!precioBaseEl) return;
    var precioBase = parseFloat(precioBaseEl.textContent.replace(/\./g, '').replace(',', '.').replace(/[^\d.]/g, '')) || 0;
    if (totalExtras > 0) {
      indicador.innerHTML =
        '<span style="color:#aaa;font-size:1.2rem">Precio base: ' + precioBase.toLocaleString('es-ES', {minimumFractionDigits:2}) + ' €</span><br>' +
        '<span style="color:#ccff00;font-size:1.2rem">+ Extras: +' + totalExtras.toLocaleString('es-ES', {minimumFractionDigits:2}) + ' €</span><br>' +
        '<span style="color:#fff;font-size:1.6rem;font-weight:bold">Total: ' + (precioBase + totalExtras).toLocaleString('es-ES', {minimumFractionDigits:2}) + ' €</span>';
      indicador.style.display = 'block';
    } else {
      indicador.style.display = 'none';
    }
  }

  async function agregarAlCarrito() {
    var variantInput = document.querySelector('form[action="/cart/add"] [name="id"], .product-variant-id');
    if (!variantInput) { alert('Error: no se encontró la variante'); return; }
    var variantId = parseInt(variantInput.value);
    var qty = parseInt((document.querySelector('[name="quantity"]') || {}).value || 1);

    var props = {};
    document.querySelectorAll('[name^="properties["]').forEach(function(el) {
      var m = el.name.match(/properties\[(.+)]/);
      if (m && el.value && el.value.trim()) props[m[1]] = el.value.trim();
    });

    var extras = recogerExtras();
    var items = [{ id: variantId, quantity: qty, properties: props }];
    Object.keys(extras).forEach(function(id) {
      items.push({ id: parseInt(id), quantity: extras[id] });
    });

    var btn = document.getElementById('smprw-btn-add');
    btn.disabled = true;
    btn.textContent = 'Añadiendo...';

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      var data = await res.json();
      if (res.ok) {
        window.location.href = '/cart';
      } else {
        alert('Error: ' + (data.description || 'inténtalo de nuevo'));
        btn.disabled = false;
        btn.textContent = 'Agregar al carrito';
      }
    } catch(err) {
      alert('Error de conexión.');
      btn.disabled = false;
      btn.textContent = 'Agregar al carrito';
    }
  }

  function init() {
    var hayFormulario = document.querySelector('div[class*="formular"]');
    if (!hayFormulario) return;

    // Inyectar indicador de precio
    var ref = document.querySelector('[id^="price-"]');
    if (ref && !document.getElementById('smprw-precio-extras')) {
      var div = document.createElement('div');
      div.id = 'smprw-precio-extras';
      div.style.cssText = 'display:none;margin-top:10px;padding:12px 16px;background:#1e1e1e;border:1px solid #ccff00;border-radius:8px;line-height:1.8';
      ref.insertAdjacentElement('afterend', div);
    }

    // Escuchar cambios de precio
    document.querySelectorAll('div[class*="formular"] select').forEach(function(s) {
      s.addEventListener('change', actualizarPrecio);
    });

    // Ocultar el botón original de Dawn y crear el nuestro
    var btnOriginal = document.querySelector('[name="add"]');
    if (btnOriginal && !document.getElementById('smprw-btn-add')) {
      btnOriginal.style.display = 'none';

      var btnNuevo = document.createElement('button');
      btnNuevo.id = 'smprw-btn-add';
      btnNuevo.type = 'button';
      btnNuevo.textContent = btnOriginal.textContent.trim() || 'Agregar al carrito';
      btnNuevo.style.cssText = btnOriginal.getAttribute('style') || '';
      btnNuevo.className = btnOriginal.className;
      btnNuevo.addEventListener('click', agregarAlCarrito);
      btnOriginal.parentNode.insertBefore(btnNuevo, btnOriginal.nextElementSibling);
      console.log('SMPRW: botón propio creado ✅');
    }
  }

  setTimeout(init, 500);
});
